export function numberAnimate() {
    let $animItems = $("[data-speed]");
    let $parentSection = $(".forrester-section");
    let $win = $(window);
    let duration;
    let flag = false;

    $win.on("scroll load", function () {

        if ($win.scrollTop() > $parentSection.offset().top - $win.height() * 0.95 && !flag) {
            flag = true;

            $animItems.each(function (i, el) {
                duration = $(el).data("speed");

                if (duration && $(el).text()) {
                    $(this).prop("Counter", 0).animate({
                        Counter: $(el).text()
                    }, {
                        duration: duration,
                        easing: "swing",
                        step: function (now) {
                            $(el).text(Math.ceil(now));
                        }
                    });
                }
            });
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/numberAnimate.js